import React from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
const useUpdateSkuStatus = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const updateSKUstatus = async (param) => {
    
    const response = await Axios.post("v2/update_sku_status", param);
    const data = await response.data;

    console.log(data, "parameter");
    if (data.code === 200) {
      toast.success("Updated SuccessFully");
    } else {
      toast.error("Update Failed");
    }
  };
  // useEffect(() => {
  //   getAllUserList();
  // }, []);
  return updateSKUstatus;
};

export default useUpdateSkuStatus;
